module.exports = __webpack_public_path__ + "img/Logo_schwarz.e01ee65b.svg";